import TasksView from '@/task-manager/TasksView.vue'
import {useContaCommand} from '@/commandbar/commandBar.service'
import {registerRoute} from '@/router'
import {useBreadCrumbs} from '@/breadcrumbs/useBreadCrumbs'
import {NavGroup, registerNavigationEntry} from '@/navigation'
import {registerHotkey} from '@/hotkeys/navigationHotkeys'
import ApproveIncomingView from '@/task-manager/ApproveIncomingView.vue'

export const TASKS = {componentName: 'TasksView', component: TasksView, meta: {requiresOrg: true}}
const {registerNavigationCommand} = useContaCommand()
const {buildSimpleCrumb} = useBreadCrumbs()
const icon = 'i-ph-files-fill'
const label = 'Bilagsmottak'
const route = TASKS

const hotkey = 'a'
registerNavigationCommand({
    route,
    label,
    icon,
    hotkey
})

registerHotkey(hotkey, TASKS)

registerNavigationEntry(NavGroup.ACCOUNTING, {
    title: label,
    key: 'incoming-documents',
    icon,
    target: route,
    sortOrder: 1,
})

registerRoute(route)
buildSimpleCrumb(route, label, icon)

export const APPROVE_INCOMING = {componentName: 'ApproveIncomingView', component: ApproveIncomingView, meta: {requiresOrg: true}}
const approveIncomingIcon = 'i-ph-list-checks'
const approveIncomingLabel = 'Godkjenne bilag'
registerNavigationCommand({
    route: APPROVE_INCOMING,
    label: approveIncomingLabel,
    icon: approveIncomingIcon,
})
registerNavigationEntry(NavGroup.ACCOUNTING, {
    title: approveIncomingLabel,
    key: 'approve-incoming-documents',
    icon: approveIncomingIcon,
    target: APPROVE_INCOMING,
    sortOrder: 2,
})
registerRoute(APPROVE_INCOMING)
buildSimpleCrumb(APPROVE_INCOMING, approveIncomingLabel, approveIncomingIcon)